// Tracked through GraphAnalyticsProvider's useAnalytics(), which already supplies the Dashboard/Graph context prefixes and panel properties.
export const GRAPH_EVENTS = {
  SERIES_ADDED: "Series Added",
  SERIES_HIDDEN: "Series Hidden",
  VIEW_MODIFIED: "View Modified",
  VIEW_RESET: "View Reset",
  // Fires when the Save-as-view drawer opens pre-populated, not when the save itself persists.
  SAVE_VIEW_STARTED: "Save View Started",
} as const
